import { useTranslation } from "react-i18next";
import HintCallout from "../../../Common/HintCallout";

/**
 * Plano com algum serviço cadastrado. Sem serviço, nenhum desconto do plano é aplicado nas
 * vendas do assinante (o desconto sai de planProducts), mesmo com a assinatura em dia.
 */
export const planHasServices = (plan) => Array.isArray(plan?.planProducts) && plan.planProducts.length > 0;

/** Plano desativado para vendas novas; quem já assina continua nele. */
export const isPlanInactive = (plan) => plan?.status === "INACTIVE";

/**
 * Avisos sobre o plano de uma assinatura, no detalhe da assinatura (na venda e em Assinaturas).
 *
 * O que prejudica o cliente é o plano sem serviços: a assinatura aparece "Ativo", mas nenhum
 * desconto é aplicado, e antes a tela só dizia em cinza "Nenhum serviço cadastrado neste plano".
 * Caso do tenant 53: 31 assinantes ficaram em planos antigos sem serviços depois que a empresa
 * criou planos novos com o mesmo nome. Plano inativo, sozinho, não é problema (é o plano que
 * saiu das vendas novas), então vira só uma informação discreta.
 *
 * @param {{plan: object}} props plano da assinatura, com planProducts e status
 */
const PlanAttentionNotices = ({ plan }) => {
    const { t } = useTranslation();
    if (!plan) {
        return null;
    }

    return (
        <>
            {!planHasServices(plan) && (
                <HintCallout icon="fa-tags" tone="warning" title={t("plan_attention.no_services_title")}>
                    {t("plan_attention.no_services_text", { name: plan.name, id: plan.id })}
                </HintCallout>
            )}
            {isPlanInactive(plan) && (
                <HintCallout icon="fa-circle-info">
                    {t("plan_attention.inactive_text")}
                </HintCallout>
            )}
        </>
    );
};

export default PlanAttentionNotices;
